import { 
    CHECK_ITEM_CODE_REG_EXP,
    I18N_CODE_VALIDATION_ERROR, 
    I18N_CODE_EXISTS_ERROR, 
    I18N_CODE_DELETED_PRODUCT_ERROR,
} from "../constant";
import { PRODUCT_URL, getSyncFetchRequest, postFetchRequest } from "../store/requests";
import {errorCallback, makeUrl} from "../util";
import i18n from "../i18nService";

class productCreateService {
    observersList = [];
    itemCode = '';
    error = '';
    basedOn = '';
    registerObserver (observer) {
        this.observersList.push(observer);
    }

    unRegisterObserver (observer) {
        this.observersList = this.observersList.filter(observerItem => observerItem !== observer);
    }

    notifyAboutCodeChanging () {
        this.observersList.forEach(observer => observer(this.itemCode));
    }

    changeItemCode (code) {
        this.error = '';
        this.itemCode = code;
        this.checkCodeValidation();
        this.notifyAboutCodeChanging();
    }

    changeBasedOn (productId) {
        this.basedOn = productId;
        this.notifyAboutCodeChanging();
    }

    checkCodeValidation (i18nInstance = i18n) {
        if(this.itemCode === undefined || this.itemCode === null || !this.itemCode.match(CHECK_ITEM_CODE_REG_EXP)) {
            this.error = i18nInstance.t(I18N_CODE_VALIDATION_ERROR);
        }
        return this.error;
    }
    
    async saveNewItem (callback) {
        const checkItemsCode = await this.findItemCodeInItems();
        if(!this.checkCodeValidation() && !checkItemsCode) {
            const preparedBody = {productCode: this.itemCode};
            this.basedOn ? preparedBody.basedOn = this.basedOn : null;
            postFetchRequest(makeUrl([PRODUCT_URL]), preparedBody, callback, errorCallback);
        } else {
            this.error = checkItemsCode;
            this.notifyAboutCodeChanging();
        }
    }

    async findItemCodeInItems(i18nInstance = i18n) {
        const listOfForms = await getSyncFetchRequest(makeUrl([PRODUCT_URL, '?withDeleted=true&withStatus=true']));
        let result = false;
        listOfForms.forEach(it => {
            if(it.productCode === this.itemCode) {
                result = it.isDeleted ? 
                    i18nInstance.t(I18N_CODE_DELETED_PRODUCT_ERROR)
                    : 
                    i18nInstance.t(I18N_CODE_EXISTS_ERROR);
            }
        });
        return result;
    }
}

export let productCreateServiceItem;

export const initializeProductCreateService = () => {
    productCreateServiceItem = new productCreateService();
};
